import React from "react";
import ServicePage from "./ServicePage";

export default function DezvoltareWebsitePage() {
  return (
    <ServicePage
      number="04"
      eyebrow="Serviciu digital"
      title={["Dezvoltare", "website."]}
      tagline="Parteneri în dezvoltarea online a afacerii tale — platforme personalizate, arhitectură solidă, prezență digitală creativă și eficientă."
      intro={[
        "Dezvoltarea unui website complet — inclusiv webshop — presupune mai multe etape. Începem cu o analiză detaliată a nevoilor și obiectivelor afacerii pentru a stabili cerințele exacte.",
        "Urmează planificarea și design-ul, cu o structură coerentă și o experiență de utilizare optimă. Etapa finală înseamnă dezvoltarea propriu-zisă — integrarea funcționalităților e-commerce, optimizarea, testarea și lansarea.",
        "Ne asigurăm că website-ul este pregătit să ofere o experiență online de succes și să contribuie la creșterea afacerii.",
      ]}
      stepsEyebrow="Transformăm proiectele în succes"
      stepsTitle="Analiză · Design · Lansare."
      steps={[
        {
          title: "Analiză și planificare",
          desc: "Stabilim obiectivele și cerințele pentru website, împreună cu structura și conținutul.",
        },
        {
          title: "Design și dezvoltare",
          desc: "Creăm aspectul și funcționalitățile, inclusiv secțiunile speciale pentru un webshop.",
        },
        {
          title: "Testare și lansare",
          desc: "Website-ul este verificat pentru erori și probleme, apoi este lansat public.",
        },
      ]}
      servicesEyebrow="Servicii web incluse"
      servicesTitle="Șase componente, un website solid."
      services={[
        {
          title: "Construcție website",
          tags: "WordPress · design predefinit · structură · meniu · submeniuri.",
          desc: "Platforma WordPress este construită cu atenție pe baza unui design de înaltă calitate. Structura, meniul și submeniurile sunt planificate cu precizie pentru o navigare fluidă și intuitivă — un website profesionist și eficient.",
        },
        {
          title: "Găzduire / hosting",
          tags: "Bandwidth · stocare · gestionare baze de date · securitate · panou de control · SSL · DNS · performanță.",
          desc: "Găzduirea este fundația tehnică ce permite website-ului să fie disponibil online. Furnizează stocare și conexiune la internet — esențială pentru funcționarea rapidă și accesibilă a site-ului, aleasă în funcție de trafic și cerințe.",
        },
        {
          title: "Optimizare SEO",
          tags: "SEO Premium · module multiple · optimizare mobil · Search Console · Core Web Vitals.",
          desc: "Creștem vizibilitatea site-ului în rezultatele motoarelor de căutare pentru a atrage un public mai mare și mai relevant. Cu plugin-ul SEO Premium integrăm module multiple pentru optimizare eficientă și personalizată, cu accent pe experiența mobil.",
        },
        {
          title: "Implementare GDPR",
          tags: "Consimțământ · drepturile utilizatorilor · politici de confidențialitate · securitatea datelor.",
          desc: "Asigurăm conformitatea cu GDPR — politici de confidențialitate, gestionarea consimțământului și protecția datelor personale. Un mediu online sigur și de încredere pentru utilizatorii tăi.",
        },
        {
          title: "Conținut text & vizual",
          tags: "Copywriting · storytelling · redactare · texte publicitare · articole blog · design grafic · fotografii · videoclipuri.",
          desc: "Ne ocupăm de crearea și actualizarea conținutului — texte relevante, imagini de calitate și elemente vizuale captivante. Conținut care reflectă identitatea și mesajele de marketing ale afacerii, comunicând eficient cu audiența țintă.",
        },
        {
          title: "Mentenanță & administrare",
          tags: "SEO Rank · scanare virus · actualizări · securitate · back-up · performanță · raport lunar.",
          desc: "Ne ocupăm de actualizările tehnice, securitate și gestionarea conținutului. Prin mentenanță preventivă și administrare atentă, îți oferim siguranța că website-ul funcționează fără probleme.",
        },
      ]}
    />
  );
}
